/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetDictionaryValues$Params {
  types: Array<string>;
}

export function getDictionaryValues(http: HttpClient, rootUrl: string, params: GetDictionaryValues$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<string>;
}>> {
  const rb = new RequestBuilder(rootUrl, getDictionaryValues.PATH, 'get');
  if (params) {
    rb.query('types', params.types, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      [key: string]: Array<string>;
      }>;
    })
  );
}

getDictionaryValues.PATH = '/dict';
